import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PriceCalculator } from '../components/PriceCalculator';
import { SubpageHero } from '../components/SubpageHero';

export function CalculatorPage() {
  return (
    <>
      <Helmet><title>Prisberegner - JNO Montage</title><meta name="description" content="Beregn din pris på varmepumpe eller pillefyr direkte her med vores online vejledende prisberegner. Gratis og uforpligtende." /></Helmet>
      <SubpageHero eyebrow="JNO Montage" title="Prisberegner" description="Få et vejledende overslag på din nye energiløsning." />
      <section className="bg-white py-16 sm:py-20 lg:py-28"><div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12"><PriceCalculator /></div></section>
    </>
  );
}
